import axios from 'axios';
import {Dialog, Toast} from "vant";
import cookies from 'vue-cookies';
import CryptoJS from 'crypto-js';

//设置秘钥和秘钥偏移量
const SECRET_KEY = CryptoJS.enc.Utf8.parse("Abdde124adf345tr");
const SECRET_IV = CryptoJS.lib.WordArray.create(CryptoJS.enc.Utf8.parse('Abdde124adf345tr'));
function encrypt(word,mweb) {
  if(mweb !=="2"){
    return word;
  }
  // return word;
  let key=CryptoJS.enc.Utf8.parse("Abdde124adf345tr");
  let iv=CryptoJS.enc.Utf8.parse("Abdde124adf345tr");
  let srcs = CryptoJS.enc.Utf8.parse(word);
  var encrypted = CryptoJS.AES.encrypt(srcs, key, {
    iv: iv,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.ZeroPadding
  });
  return CryptoJS.enc.Base64.stringify(encrypted.ciphertext);
}
//
// // 假设你有一个加密函数
// function encryptParams(params) {
//   if(!params){
//     return "";
//   }
//   // 使用 CryptoJS 或其他库进行加密
//   // 这里只是一个示例，你需要替换为实际的加密逻辑
//   const encryptedParams = CryptoJS.AES.encrypt(JSON.stringify(params), 'qhywt23232323232', {
//     mode: CryptoJS.mode.ECB, // 加密模式，需要与前端一致
//     padding: CryptoJS.pad.Pkcs7 // 填充模式，需要与前端一致
//   }).toString();
//   return encryptedParams;
// }
//'http://localhost:8081/api',
//'Content-Type': 'application/json;charset=UTF-8'
let http = axios.create({
    baseURL: process.env.API_HOST,
    timeout:25000,
    withCredentials: true,
    headers: {
        'Content-Type': 'application/json;charset=utf-8'
    },
    // transformRequest: [function (data) {
    //     let newData = '';
    //     for (let k in data) {
    //         if (data.hasOwnProperty(k) === true) {
    //             newData += encodeURIComponent(k) + '=' + encodeURIComponent(data[k]) + '&';
    //         }
    //     }
    //     return newData;
    // }]
});

// let pending = []; //声明一个数组用于存储每个ajax标识
// let cancelToken = axios.CancelToken;
// let removeRepeatUrl = (config) => {
//   let key=`${config.url}-${config.method}-${JSON.stringify(config.params)}-${JSON.stringify(config.data)}`;
//   let index = pending.indexOf(key);
//   if (index!==-1){   //当当前请求在数组中存在
//     pending.splice(index,1) //把这条记录从数组中移除
//   }
// };
// // 请求拦截器，将请求的标志暂存到数组中，防止重复提交
// http.interceptors.request.use(config => {
//   config.cancelToken = new cancelToken((c)=>{
//     // 在这里阻止重复请求，上个请求未完成时，相同的请求不会再次执行
//     let key=`${config.url}-${config.method}-${JSON.stringify(config.params)}-${JSON.stringify(config.data)}`;
//     console.log(key);
//     pending.indexOf(key)!==-1?c('请勿重复操作'):pending.push(key);
//   });
//   return config
// }, err => {
//   return Promise.reject(err)
// });

// POST传参序列化(添加请求拦截器)
http.interceptors.request.use((config) => {
  let mweb="1";
  if(config.url && config.url.indexOf("attach/")<0){
    mweb="2"
    config.data=encrypt(JSON.stringify(config.data),mweb);
  }
  // 发送请求前之前做某件事
  // Toast({
  //   type: 'loading',
  //   loadingType:'spinner',
  //   message: '加载中...'
  // });
  const openId = cookies.get('openId');
  const token=cookies.get('token');
  const wuType=cookies.get('wuType');
  const userId=cookies.get('userId');
  const partyId=cookies.get('partyId');
  // 下面两种方式都行
  // config.headers.accessToken = openId
  // config.headers['W-OpenId-Token'] = openId||"";
  // config.headers['W-UserId-Token'] = userId||"";
  // config.headers['W-WuType-Token'] = wuType||"";
  config.headers['m-uo'] = encrypt(openId,mweb)||"";
  config.headers['m-web'] =mweb;
  //用户类型
  config.headers['m-wt'] = encrypt(wuType,mweb)||"";
  //token
  config.headers['m-ui'] = encrypt(userId,mweb)||"";
  //token
  config.headers['m-tk'] = encrypt(token,mweb)||"";
  //partyId
  config.headers['m-pi'] = encrypt(partyId,mweb)||"";
  //token
  config.headers['_ct'] = "9";
  //token
  config.headers['_sk'] = "app";
  config.headers['m-so'] = "2";
  return config;
}, (error) => {
  console.log('错误的传参');
  return Promise.reject(error)
});

// 返回状态判断（添加响应拦截器）
http.interceptors.response.use((res) => {
  // Toast.clear();
  return res;
}, (error) => {
  Dialog.alert({
    // message: error.response.data.msg
    message: error
  })

  //清空数组
  // pending=[];
  // 对响应错误做点什么
  return Promise.reject(error);
});


function apiAxios(method, url, params, response,headers) {
  let config={
    method: method,
    url: url,
    data: method === 'POST' || method === 'PUT' ? params : null,
    params: method === 'GET' || method === 'DELETE' ? params : null,
  };
  if (headers){
    config.headers=headers;
    config.transformRequest=[];
  }
  http(config).then(res=>{
    response(res)
  }).catch(err=>{
    console.log(err);})
}

export default {
    get: function (url, params, response) {
        return apiAxios('GET', url, params, response)
    },
    post: function (url, params, response) {
        return apiAxios('POST', url, params, response)
    },
    postFile: function (url, params, response) {
        return apiAxios('POST', url, params, response,{'Content-Type': 'multipart/form-data;boundary='+new Date().getTime()})
    },
    put: function (url, params, response) {
        return apiAxios('PUT', url, params, response)
    },
    delete: function (url, params, response) {
        return apiAxios('DELETE', url, params, response)
    }
}



// WEBPACK FOOTER //
// ./src/api/http_util.js